import { Alert, Box } from '@zillow/constellation-10';

const SFCostAndFeesTotalMonthlyPriceWithFeeAlert = () => (
  <Box data-testid="SFCostAndFeesTotalMonthlyPriceWithFeeAlert" css={{ marginBottom: '600' }}>
    <Alert role="alert">
      Any required monthly fees will be combined with base rent and a “total monthly price” label will be added to your
      listing. You can also indicate if certain fees are already included in base rent.
    </Alert>
  </Box>
);

export default SFCostAndFeesTotalMonthlyPriceWithFeeAlert;
